import React, { Component } from "react";
import { Image, Pagination } from "antd";
import ImageListPreview from "../../components/ImageListPreview";

export default class ImageWall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 100,
    };
  }
  showImages = (data, page, pageSize) => {
    const imageStart = pageSize * page - pageSize;
    const imageEnd = pageSize * page;
    const images = data.slice(imageStart, imageEnd);

    return <ImageListPreview images={images} height={100} width={""} />;
  };

  changePage = (p) => {
    this.setState({
      page: p,
    });
  };

  changePageSize = (current, pageSize) => {
    this.setState({
      pageSize: pageSize,
    });
  };

  render() {
    const { page } = this.state;
    const { pageSize } = this.state;
    return (
      <>
        {this.showImages(this.props.data, page, pageSize)}
        <Pagination
          style={{ width: "100%", textAlign: "center", marginTop: "50px" }}
          onChange={this.changePage}
          onShowSizeChange={this.changePageSize}
          defaultCurrent={page}
          pageSize={pageSize}
          total={this.props.data.length}
        />
      </>
    );
  }
}
